/**
 * Text avatars for people: initials on a colour that stays the same for the
 * same monday user id, wherever they show (People cells, Share with).
 */
const AVATAR_COLORS = [
  '#0073ea', '#a25ddc', '#00c875', '#e2445c', '#fdab3d',
  '#579bfc', '#66ccff', '#ff642e', '#7f5347', '#c4c4c4',
];

export const initialsOf = (name) =>
  String(name || '?')
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

export const avatarColor = (id) => AVATAR_COLORS[Math.abs(Number(id) || 0) % AVATAR_COLORS.length];
